import type { FC, SVGProps } from "react";

const ProgramBook: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="program book icon">
      {/* <title>program book icon</title> */}
      <g clipPath="url(#clip0_832_203)">
        <path
          d="M12.7026 0L12.7007 0.908961L23.2526 7.97338V20.9613C23.2516 21.4221 23.1124 21.8717 22.8536 22.2499C22.5948 22.6281 22.2288 22.9169 21.8044 23.0777C21.4691 23.2045 21.1086 23.2468 20.7538 23.201C20.3989 23.1551 20.0602 23.0226 19.7666 22.8146C19.4731 22.6067 19.2333 22.3295 19.0679 22.0067C18.9024 21.684 18.8162 21.3253 18.8166 20.9613V9.51937L7.51728 1.95484L7.51915 2.25529V2.28952L7.37714 6.9294L7.34911 7.82315L13.8966 12.2044V21.0811C13.8972 21.5353 13.7565 21.9781 13.4947 22.3459C13.2329 22.7138 12.8634 22.988 12.4391 23.1291C12.121 23.2351 11.7828 23.263 11.4521 23.2104C11.1213 23.1578 10.8076 23.0262 10.5365 22.8264C10.2654 22.6265 10.0447 22.3642 9.89241 22.0608C9.74016 21.7575 9.6607 21.4217 9.66054 21.0811V13.4614L7.22765 11.8317L0 6.99406V16.6789L10.0735 23.4219C10.0814 23.4299 10.0902 23.4369 10.0997 23.4428C10.1843 23.5054 10.2723 23.5631 10.3631 23.6159C10.7911 23.8668 11.2762 23.9993 11.7702 24C12.0768 23.9994 12.3814 23.9493 12.6727 23.8517C13.2465 23.6605 13.7461 23.2896 14.1002 22.7919C14.4543 22.2943 14.6446 21.6955 14.644 21.0811V20.2672L19.2912 23.4029L19.3005 23.4086C19.3136 23.42 19.3267 23.4295 19.3398 23.439C19.3865 23.4714 19.4332 23.5037 19.4799 23.5303C19.863 23.7703 20.2947 23.9186 20.7424 23.9641C21.19 24.0096 21.642 23.951 22.0642 23.7927C22.6314 23.577 23.1205 23.1904 23.4664 22.6845C23.8123 22.1787 23.9984 21.5775 24 20.9613V7.56454L12.7026 0Z"
          fill={props.fill || "currentColor" || "#0C365C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_832_203">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProgramBook;
